<div class="w-full h-full p-5 relative">
  <div style="height: calc(100% - 100px)" class="overflow-auto">
    <div class="text-center mb-3">
      <h3 class="font-semibold">Current space "{{ state.activeSpace }}" can't be loaded (pending git migration)</h3>
    </div>
    <div class="text-center">
      <div class="fs-1 font-normal">
        The format of some files in the current branch "{{ state.activeBranchName }}" have changed and a git migration
        need to be applied but you do not have permission to do so. Please, wait until an {{ state.ownerLabel }} or
        {{ state.administratorLabel }} applies the migration.
      </div>
    </div>
  </div>
</div>
